<script lang="ts" setup>
import { useAppStore } from '~/stores/app'
import * as Sentry from '@sentry/nuxt'
import Loading from '~/component/Loading.vue'
import Dialog from '~/component/Dialog.vue'
import Alert from '~/component/Alert.vue'
import NoticePopup from '~/component/NoticePopup.vue'
const router = useRouter()
const route = useRoute()

onMounted(() => {
  //  console.log(import.meta.env.VITE_ENV)
  /*console.log(import.meta.env.VITE_SENTRY_AUTH_TOKEN)
  console.log(import.meta.env.VITE_SENTRY_DSN)*/

  if (import.meta.env.VITE_ENV === 'DEV') {
    console.log(import.meta.env.VITE_GTAG_ID)
    const gtagID = import.meta.env.VITE_GTAG_ID
    const script = document.createElement('script')

    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []

    window.gtag = function () {
      window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())
    window.gtag('config', gtagID)
  }
  /*Sentry.init({
    dsn: 'https://c9e92c16707cd3252c7b152bb13ff77b@o4509563494989824.ingest.us.sentry.io/4509564201664512',
    environment: 'production',
    // tracesSampleRate를 0.1로 설정하면, 10%의 트랜잭션 이벤트만 Sentry로 전송됩니다. 필요에 따라 비율을 조정 가능합니다.
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.replayIntegration()],

    //debug: false,
  })*/
})
</script>
<template>
  <!--  <div>-->
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <Dialog />
  <Loading />
  <Alert />
  <NoticePopup v-if="!route.path.includes('/print')" />
  <!--  </div>-->
</template>
